import { render, staticRenderFns } from "./FaultSummaryTable.vue?vue&type=template&id=0153ac06&scoped=true"
import script from "./FaultSummaryTable.vue?vue&type=script&lang=js"
export * from "./FaultSummaryTable.vue?vue&type=script&lang=js"
import style0 from "./FaultSummaryTable.vue?vue&type=style&index=0&id=0153ac06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0153ac06",
  null
  
)

export default component.exports